import ProductSlider from "../../../Components/Sliders/ProductSlider/ProductSlider";
import { useNewProducts } from "../../../Hooks/useProductsBySubCategory";

export const BestSellingProducts = () => {
  const { products, loading } = useNewProducts();

  return (
    <ProductSlider title="Best Selling Products" link="/" products={products} loading={loading} />
  );
};
